import { useRef } from 'react';

import dynamic, { LoaderComponent } from 'next/dynamic';

import { IM190BrandOverviewModule } from '~/lib/data-contract';
import { type CarouselProps } from '~/shared/components/Carousel/Carousel';
import { type CarouselControlsProps } from '~/shared/components/Carousel/components/CarouselControls';
import { M190StorySkeleton } from '~/templates/blocks/components/M190BrandOverviewStories/components/M190Story/M190StorySkeleton';

import styles from './m190stories.module.css';

import { M190Story } from '../M190Story/M190Story';

export type M190StoriesProps = Pick<IM190BrandOverviewModule, 'items'>;

// Minor skeleton thingie to keep CLS to a minimum while the carousel lazyloads.
const carouselFallback = (
	<div className={styles.root}>
		<M190StorySkeleton />
	</div>
);

// These aren't too important for first-load, so we'll just load 'em dynamically
const DynamicCarousel = dynamic(() => import('~/shared/components/Carousel/Carousel').then((module) => module.Carousel) as LoaderComponent<CarouselProps>, {
	ssr: false,
	loading: () => carouselFallback,
});
const DynamicCarouselControls = dynamic(() => import('~/shared/components/Carousel/components/CarouselControls').then((module) => module.CarouselControls) as LoaderComponent<CarouselControlsProps>, {
	ssr: false,
});

export const M190Stories = ({ items }: M190StoriesProps) => {
	const prevRef = useRef<HTMLButtonElement>(null);
	const nextRef = useRef<HTMLButtonElement>(null);

	const refs = {
		prevRef,
		nextRef,
	};

	if (!items.length) {
		return null;
	}

	return (
		<div className={styles.root}>
			<DynamicCarouselControls
				className={styles.controls}
				{...refs}
			/>
			<DynamicCarousel
				{...refs}
				items={items.map((item) => (
					<M190Story {...item} />
				))}
			/>
		</div>
	);
};
